import axios from '../api/axios';
import { toast } from 'react-toastify';

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

/* ----------------------------------------------------------------------------
   Helper: build _unset for cleared (empty string) fields + clean payload
   - Explicitly supports Clients (contacts + address.* + preferredContactMethod)
   - Merges with any existing _unset passed by caller
----------------------------------------------------------------------------- */
function preparePayload(type, payload) {
  const p = JSON.parse(JSON.stringify(payload || {})); // deep clone to mutate safely
  let unset = Array.isArray(p._unset) ? [...p._unset] : [];

  if (type === 'clients') {
    // flat keys that should clear when ''
    const flatNullable = [
      'email',
      'secondaryEmail',
      'phone',
      'secondaryPhone',
      'preferredContactMethod',
      'company',
      'industry',
      'website',
      'source',
      'contactPerson',
    ];

    flatNullable.forEach((k) => {
      if (p[k] === '') {
        unset.push(k);
        delete p[k];
      }
    });

    // nested address.* (if present)
    if (p.address && typeof p.address === 'object') {
      const addrMap = {
        street: 'address.street',
        city: 'address.city',
        state: 'address.state',
        zip: 'address.zip',
        country: 'address.country',
        raw: 'address.raw',
      };
      Object.keys(addrMap).forEach((k) => {
        if (p.address[k] === '') {
          unset.push(addrMap[k]);
          delete p.address[k];
        }
      });
      // drop empty address object to avoid `$set: {address:{}}`
      if (!Object.keys(p.address).length) delete p.address;
    }
  }

  // de-dupe and attach _unset only if needed
  unset = Array.from(new Set(unset));
  if (unset.length) p._unset = unset;
  else delete p._unset;

  return p;
}

/* --------------------------------- Actions --------------------------------- */

export const handleAddItem = async (type, payload, onSuccess, onClose) => {
  try {
    await axios.post(`/${type}`, payload);
    toast.success(`${capitalize(type)} added`);
    onSuccess?.();
    onClose?.();
  } catch (err) {
    console.error(err);
    toast.error(`Failed to add ${type}`);
  }
};

export const handleEditItem = async (type, id, payload, onSuccess, onClose) => {
  try {
    const body = preparePayload(type, payload);
    await axios.put(`/${type}/${id}`, body);
    toast.success(`${capitalize(type)} updated`);
    onSuccess?.();
    onClose?.();
  } catch (err) {
    console.error(err);
    toast.error(`Failed to update ${type}`);
  }
};

export const handleDeleteItem = async (type, id, onRefresh) => {
  if (!window.confirm(`Delete this ${capitalize(type)}?`)) return;
  try {
    await axios.delete(`/${type}/${id}`);
    toast.success(`${capitalize(type)} deleted`);
    onRefresh?.();
  } catch (err) {
    console.error(err);
    toast.error(`Failed to delete ${type}`);
  }
};
